import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4333c736&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4333c736",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4333c736')) {
      api.createRecord('4333c736', component.options)
    } else {
      api.reload('4333c736', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4333c736&scoped=true&", function () {
      api.rerender('4333c736', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/page_marginnote_landing/components/PaidModal/index.vue"
export default component.exports